/* ============================================================
   VENT D'HIVER — LAUNCH SYSTEM
   Production · Hardened · Minimal motion
   ============================================================ */
(function () {
  'use strict';

  /* ---------- CONSTANTS ---------- */
  var STORAGE_VERSION = 'v4';
  var MAX_EMAIL_LEN = 254;
  var MIN_PROBABILITY = 0;
  var MAX_PROBABILITY = 100;
  var SIGNATURE_SALT = 'vdh_launch_2026';

  /* ---------- TIMING ---------- */
  function getTimings(durationMin) {
    if (durationMin === 15) {
      return {
        PARTICIPATION_BEFORE_MS: 15 * 60 * 1000,
        ENTRIES_CLOSE_BEFORE_MS:  7 * 60 * 1000,
        DRAWING_BEFORE_MS:        60 * 1000,
        DRAW_DURATION_MS:         60 * 1000,
        RESULT_EXPIRE_AFTER_MS:  10 * 60 * 1000
      };
    }
    return {
      PARTICIPATION_BEFORE_MS: 30 * 60 * 1000,
      ENTRIES_CLOSE_BEFORE_MS: 15 * 60 * 1000,
      DRAWING_BEFORE_MS:       60 * 1000,
      DRAW_DURATION_MS:        60 * 1000,
      RESULT_EXPIRE_AFTER_MS: 10 * 60 * 1000
    };
  }

  /* ---------- ZONES ---------- */
  var CITIES = {
    paris:       { name: 'Paris',       lat: 48.8566, lng:    2.3522, radius: 15 },
    toronto:     { name: 'Toronto',     lat: 43.6532, lng:  -79.3832, radius: 25 },
    new_york:    { name: 'New York',    lat: 40.7128, lng:  -74.0060, radius: 22 },
    los_angeles: { name: 'Los Angeles', lat: 34.0522, lng: -118.2437, radius: 30 },
    las_vegas:   { name: 'Las Vegas',   lat: 36.1699, lng: -115.1398, radius: 20 },
    montreal:    { name: 'Montreal',    lat: 45.5017, lng:  -73.5673, radius: 22 }
  };
  var COUNTRIES = {
    FR: { name: 'France',      bbox: [41.3,  -5.2, 51.1,   9.6] },
    US: { name: 'USA',         bbox: [24.5, -125.0, 49.4, -66.9] },
    CA: { name: 'Canada',      bbox: [41.7, -141.0, 83.1, -52.6] },
    GB: { name: 'UK',          bbox: [49.9,  -8.6,  60.9,   1.8] },
    DE: { name: 'Germany',     bbox: [47.3,   5.8,  55.0,  15.0] },
    IT: { name: 'Italy',       bbox: [36.6,   6.6,  47.1,  18.5] },
    ES: { name: 'Spain',       bbox: [36.0,  -9.5,  43.8,   3.3] },
    BE: { name: 'Belgium',     bbox: [49.5,   2.5,  51.5,   6.4] },
    NL: { name: 'Netherlands', bbox: [50.7,   3.4,  53.5,   7.2] },
    JP: { name: 'Japan',       bbox: [24.0, 122.9,  45.5, 145.8] }
  };

  /* ---------- UTILS ---------- */
  function haversineKm(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function secureRandom() {
    try {
      if (window.crypto && window.crypto.getRandomValues) {
        var buf = new Uint32Array(1);
        window.crypto.getRandomValues(buf);
        return buf[0] / 0x100000000;
      }
    } catch (e) {}
    return Math.random();
  }

  /* Simple signature for anti-tampering of localStorage result */
  function signValue(value, launchId) {
    var str = STORAGE_VERSION + ':' + launchId + ':' + value + ':' + SIGNATURE_SALT;
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = ((hash << 5) - hash) + str.charCodeAt(i);
      hash |= 0;
    }
    return Math.abs(hash).toString(36);
  }

  /* Storage with namespace and validation */
  var memStore = {};
  var hasLS = (function () {
    try {
      var k = '__vdh_test__';
      localStorage.setItem(k, '1');
      localStorage.removeItem(k);
      return true;
    } catch (e) { return false; }
  })();

  function lsGet(k) {
    if (hasLS) {
      try { return localStorage.getItem(k); } catch (e) { return null; }
    }
    return memStore[k] != null ? memStore[k] : null;
  }
  function lsSet(k, v) {
    if (typeof v !== 'string') v = String(v);
    if (hasLS) {
      try { localStorage.setItem(k, v); return; } catch (e) {}
    }
    memStore[k] = v;
  }
  function lsDel(k) {
    if (hasLS) {
      try { localStorage.removeItem(k); } catch (e) {}
    }
    delete memStore[k];
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* Strict email validation — RFC-aware but conservative */
  function isValidEmail(e) {
    if (typeof e !== 'string') return false;
    if (e.length < 5 || e.length > MAX_EMAIL_LEN) return false;
    if (/[\s<>"']/.test(e)) return false;
    return /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(e);
  }

  function parseDate(s) {
    if (!s || typeof s !== 'string') return null;
    var d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  }

  function clamp(n, mn, mx, fb) {
    if (typeof n !== 'number' || isNaN(n)) return fb;
    return Math.max(mn, Math.min(mx, n));
  }

  function safeInt(v, fb) {
    var n = parseInt(v, 10);
    return isNaN(n) ? fb : n;
  }

  function csvList(s) {
    if (!s || typeof s !== 'string') return [];
    return s.split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
  }
  function upperList(s) {
    if (!s || typeof s !== 'string') return [];
    return s.split(',').map(function (x) { return x.trim().toUpperCase(); }).filter(Boolean);
  }
  function pipeList(s) {
    if (!s || typeof s !== 'string') return [];
    return s.split('||').map(function (x) { return x.trim(); }).filter(Boolean);
  }

  function formatNum(n) {
    if (typeof n !== 'number' || isNaN(n)) n = 0;
    return Math.floor(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* Safe URL — only allow same-origin or relative URLs as exit targets */
  function safeUrl(url, fallback) {
    if (!url || typeof url !== 'string') return fallback;
    try {
      var u = new URL(url, window.location.origin);
      if (u.origin === window.location.origin) return u.pathname + u.search + u.hash;
      // External — allow only http/https
      if (u.protocol === 'http:' || u.protocol === 'https:') return u.href;
      return fallback;
    } catch (e) {
      return fallback;
    }
  }

  /* ---------- INCOGNITO DETECTION ----------
   * Detects private / incognito mode across browsers.
   * Used to block flow because Shopify form post → redirect
   * loses localStorage state in some private modes.
   * Returns a promise resolving to true if private mode detected.
   */
  function detectIncognito() {
    return new Promise(function (resolve) {
      // 0. Quick localStorage write test — catches Safari iOS private
      try {
        var probe = '__vdh_priv_' + Math.random();
        window.localStorage.setItem(probe, '1');
        window.localStorage.removeItem(probe);
      } catch (e) {
        return resolve(true);
      }

      // 1. Chromium / Edge / Brave private mode via storage quota
      try {
        if (navigator.storage && navigator.storage.estimate) {
          navigator.storage.estimate().then(function (est) {
            // In incognito, quota is artificially limited
            // Normal: several GB; private: typically < 120MB on Chromium
            var quotaMB = (est.quota || 0) / 1048576;
            if (quotaMB > 0 && quotaMB < 120) return resolve(true);
            // 2. Firefox private — IndexedDB throws or DB never opens
            checkIndexedDB(resolve);
          }, function () {
            checkIndexedDB(resolve);
          });
          return;
        }
      } catch (e) {}

      checkIndexedDB(resolve);
    });
  }

  function checkIndexedDB(resolve) {
    // Firefox private mode disables IndexedDB entirely or makes open() error
    try {
      if (!window.indexedDB) return resolve(true);
      var req = window.indexedDB.open('__vdh_priv_check__');
      var settled = false;
      req.onerror = function () {
        if (!settled) { settled = true; resolve(true); }
      };
      req.onsuccess = function () {
        if (settled) return;
        settled = true;
        try { window.indexedDB.deleteDatabase('__vdh_priv_check__'); } catch (e) {}
        resolve(false);
      };
      // Timeout safety — assume not private if we get nothing in 1.5s
      setTimeout(function () {
        if (!settled) { settled = true; resolve(false); }
      }, 1500);
    } catch (e) {
      resolve(true);
    }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () { $$('[data-vdh]').forEach(initInstance); });

  /* Build ISO date string from 5 separate fields, then parse */
  function buildDropDate(d) {
    var date = (d.dropDate || '').trim();
    var hour = safeInt(d.dropHour, 8);
    var minute = (d.dropMinute || '00').trim();
    var meridiem = (d.dropMeridiem || 'PM').trim().toUpperCase();
    var tz = (d.dropTz || '+02:00').trim();

    // Validate date format YYYY-MM-DD
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return null;

    // Validate hour 1-12
    if (hour < 1 || hour > 12) return null;

    // Validate minute (must be 2 digits)
    if (!/^\d{2}$/.test(minute)) return null;

    // Convert 12h → 24h
    var h24 = hour;
    if (meridiem === 'AM') {
      if (hour === 12) h24 = 0;
    } else {
      if (hour !== 12) h24 = hour + 12;
    }

    // Validate timezone format
    if (!/^[+-]\d{2}:\d{2}$/.test(tz)) tz = '+00:00';

    var iso = date + 'T' + pad(h24) + ':' + minute + ':00' + tz;
    return parseDate(iso);
  }

  /* ---------- INSTANCE ---------- */
  function initInstance(root) {
    var d = root.dataset;
    var dropAt = buildDropDate(d);
    var durationMin = safeInt(d.durationMinutes, 30);
    if (durationMin !== 15 && durationMin !== 30) durationMin = 30;
    var T = getTimings(durationMin);

    var launchId = (d.launchId || 'default').trim().replace(/[^a-zA-Z0-9_\-]/g, '').substring(0, 64) || 'default';

    var cfg = {
      launchId: launchId,
      locksmithUrl: safeUrl(d.locksmithUrl, ''),
      exploreUrl: safeUrl(d.exploreUrl, '/collections/all'),
      exitUrl: safeUrl(d.exitUrl, '/'),
      disableSelection: d.disableAccessSelection === 'true',
      probability: clamp(safeInt(d.accessProbability, 50), MIN_PROBABILITY, MAX_PROBABILITY, 50),
      durationMin: durationMin,
      timings: T,
      dropAt: dropAt,
      partOpensAt: dropAt ? new Date(dropAt.getTime() - T.PARTICIPATION_BEFORE_MS) : null,
      entriesCloseAt: dropAt ? new Date(dropAt.getTime() - T.ENTRIES_CLOSE_BEFORE_MS) : null,
      drawStartsAt: dropAt ? new Date(dropAt.getTime() - T.DRAWING_BEFORE_MS) : null,
      unlockAt: dropAt,
      resultsExpireAt: dropAt ? new Date(dropAt.getTime() + T.RESULT_EXPIRE_AFTER_MS) : null,
      tzLabel: (d.timezoneLabel || '').trim().substring(0, 64),
      preview: (d.previewMode || 'live').trim(),
      geoEnabled: d.geoEnabled === 'true',
      geoMode: (d.geoMode || 'cities').trim() === 'countries' ? 'countries' : 'cities',
      geoCountries: upperList(d.geoCountries || ''),
      geoCities: csvList(d.geoCities || ''),
      waitingStatuses: pipeList(d.waitingStatuses || ''),
      waitingMessages: pipeList(d.waitingMessages || ''),
      submitDefault: (d.submitDefault || 'CONFIRM ENTRY').trim().substring(0, 64)
    };
    if (!cfg.waitingStatuses.length) {
      cfg.waitingStatuses = ['PREPARING THE DRAW', 'SECURING THE QUEUE', 'VERIFYING ENTRIES', 'ALMOST THERE'];
    }
    if (!cfg.waitingMessages.length) {
      cfg.waitingMessages = ['SECURE QUEUE ACTIVE', 'HOLD POSITION', 'STAND BY', 'DO NOT REFRESH'];
    }

    var keys = {
      result: 'vdh_' + STORAGE_VERSION + '_' + cfg.launchId + '_result',
      entered: 'vdh_' + STORAGE_VERSION + '_' + cfg.launchId + '_entered',
      ts: 'vdh_' + STORAGE_VERSION + '_' + cfg.launchId + '_ts',
      sig: 'vdh_' + STORAGE_VERSION + '_' + cfg.launchId + '_sig'
    };

    var els = {
      views: {},
      form: $('#vdh-form', root) || $('.vdh__form', root),
      email: $('[data-email]', root),
      firstname: $('[data-firstname]', root),
      lastname: $('[data-lastname]', root),
      optin: $('[data-optin]', root),
      submit: $('[data-submit]', root),
      submitLabel: $('[data-submit-label]', root),
      error: $('[data-error]', root),
      timeD: $('[data-time="drop"]', root),
      entry: $('[data-entry-countdown]', root),
      flipclock: $('[data-flipclock]', root),
      progress: $('[data-progress]', root),
      waitingOverlay: $('[data-overlay]', root),
      waitingMessage: $('[data-waiting-message]', root),
      waitingStatus: $('[data-waiting-status]', root),
      drawStream: $('[data-stream-line]', root),
      drawTime: $('[data-draw-time]', root),
      modal: $('[data-modal]', root),
      mapZone: $('[data-map-zone]', root),
      mapRings: $('[data-map-rings]', root),
      mapDot: $('[data-map-dot]', root),
      mapStatus: $('[data-map-status]', root),
      zonesList: $('[data-zones-list]', root),
      zonesValue: $('[data-zones-value]', root),
      arrivalDate: $('[data-arrival-date]', root),
      arrivalTime: $('[data-arrival-time]', root),
      arrivalCountdown: $('[data-arrival-countdown]', root),
      arrivalCountdownRow: $('[data-arrival-countdown-row]', root),
      accessScope: $('[data-access-scope]', root),
      gps: $('[data-gps]', root),
      gpsCoords: $('[data-gps-coords]', root),
      gpsLabel: $('[data-gps-label]', root),
      debugReset: $('[data-debug-reset]', root)
    };
    $$('[data-view]', root).forEach(function (v) {
      var name = v.getAttribute('data-view');
      if (name) els.views[name] = v;
    });

    var state = {
      root: root,
      cfg: cfg,
      keys: keys,
      els: els,
      current: null,
      timers: {},
      submitting: false,
      lastFlipDigits: ['0', '0', '0', '0'],
      drawRaf: null,
      transitioning: false,
      geoVerified: false,
      geoRequesting: false
    };

    renderArrival(state);
    renderZonesList(state);
    renderAccessScope(state);
    bindEvents(state);
    setupScrollDetection(state);

    // Handle Shopify form post-redirect. This should only come from the main
    // "join the draw" form. CRITICAL: only mark entered if the participation
    // window is actually open. If `customer_posted=true` arrives while phase
    // is still 'before' (drop not opened yet), it means the post came from the
    // pre-launch notify form (or some other path) and the user has NOT joined
    // the draw. We must NOT mark them as entered.
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      var currentPhase = computePhase(cfg);
      var isBeforeLaunch = currentPhase === 'before' || currentPhase === 'closed';
      if (!isBeforeLaunch && !isEntered(state)) {
        var fallback = decideAccess(cfg);
        markEntered(state, fallback);
        // If geo was the gate, mark verified too — the user already passed locating
        if (cfg.geoEnabled) state.geoVerified = true;
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        url.hash = '';
        window.history.replaceState({}, document.title, url.pathname + (url.search || ''));
      } catch (e) {}
    }

    boot(state);

    state.timers.tick = setInterval(function () {
      reevaluate(state);
    }, 5000);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) reevaluate(state);
    });
  }

  /* ---------- ANIMATION ENTRY ---------- */
  function animateIn(view) {
    if (!view) return;
    var STEP = 90; // ms between each element's entrance
    var els = $$('[data-anim="fade-up"]', view);
    if (!els.length) return;

    // Reset instantly (transition disabled) so re-showing a view never
    // produces a fade-out-then-in flicker.
    els.forEach(function (el) {
      el.style.transition = 'none';
      el.style.transitionDelay = '0ms';
      el.classList.remove('is-in');
    });
    // Force reflow so the instant reset is committed before we animate.
    void view.offsetWidth;

    // Play the cascade. Delays are computed from DOM order, so the rhythm
    // stays perfect regardless of which optional elements are present
    // (hidden title, no media, etc.) — no hardcoded per-element delays.
    requestAnimationFrame(function () {
      els.forEach(function (el, i) {
        el.style.transition = '';                       // restore CSS transition
        el.style.transitionDelay = (i * STEP) + 'ms';
        el.classList.add('is-in');
      });
    });
  }

  /* ---------- VIEW SWITCH ---------- */
  function show(state, name) {
    if (state.current === name || !state.els.views[name]) return;
    var prev = state.current;
    var views = state.els.views;
    var nextView = views[name];

    if (state.timers.transition) {
      clearTimeout(state.timers.transition);
      state.timers.transition = null;
    }

    state.transitioning = true;

    // Stop view-specific timers when leaving
    if (prev === 'waiting') stopWaitingExtras(state);
    if (prev === 'drawing') stopDrawing(state);
    if (prev === 'intro') stopEntryCountdown(state);
    if (prev === 'locating') {
      if (state.timers.geoFollowup) {
        clearTimeout(state.timers.geoFollowup);
        state.timers.geoFollowup = null;
      }
    }

    // Hide all, then show target
    Object.keys(views).forEach(function (k) {
      var v = views[k];
      v.classList.remove('is-active');
      if (k !== name) {
        v.hidden = true;
      }
    });

    nextView.hidden = false;

    // Force reflow then activate
    void nextView.offsetWidth;
    requestAnimationFrame(function () {
      nextView.classList.add('is-active');
      animateIn(nextView);
    });

    state.current = name;
    state.root.setAttribute('data-state', name);

    // Release the transition guard after the fade completes (~600ms based on CSS --dur)
    state.timers.transition = setTimeout(function () {
      state.transitioning = false;
      state.timers.transition = null;
    }, 650);

    // Reset scroll state when switching views — each view has its own scrollTop,
    // and the new view always starts at the top. Without this reset, the fade
    // bands + footer would stay visible after leaving a previously-scrolled view.
    state.root.setAttribute('data-scrolled', 'false');

    // Start view-specific logic
    if (name === 'intro') startEntryCountdown(state);
    if (name === 'waiting') startWaitingCountdown(state);
    if (name === 'drawing') startDrawing(state);
    if (name === 'locating') startLocating(state);
  }

  /* ---------- SCROLL DETECTION ----------
   * Each view scrolls internally (overflow-y: auto). When the active view
   * has been scrolled even a few px, we set data-scrolled="true" on .vdh.
   * CSS uses that to fade in the top + bottom mask bands and the marquee
   * footer. When at the top, none of that overlay is visible, keeping the
   * layout clean when content fits the viewport. */
  function setupScrollDetection(state) {
    var root = state.root;
    var ticking = false;

    function onScroll(e) {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var scrolled = e.target.scrollTop > 4;
        var current = root.getAttribute('data-scrolled') === 'true';
        if (scrolled !== current) {
          root.setAttribute('data-scrolled', scrolled ? 'true' : 'false');
        }
      });
    }

    Object.keys(state.els.views).forEach(function (k) {
      state.els.views[k].addEventListener('scroll', onScroll, { passive: true });
    });

    // Explicit initial state
    root.setAttribute('data-scrolled', 'false');
  }

  function stopEntryCountdown(state) {
    if (state.timers.entry) {
      clearInterval(state.timers.entry);
      state.timers.entry = null;
    }
  }
  function stopWaitingExtras(state) {
    ['wait', 'status', 'queue'].forEach(function (k) {
      if (state.timers[k]) {
        clearInterval(state.timers[k]);
        state.timers[k] = null;
      }
    });
  }
  function stopDrawing(state) {
    if (state.timers.drawTime) {
      clearInterval(state.timers.drawTime);
      state.timers.drawTime = null;
    }
    if (state.timers.drawRestart) {
      clearTimeout(state.timers.drawRestart);
      state.timers.drawRestart = null;
    }
    if (state.timers.drawEnd) {
      clearTimeout(state.timers.drawEnd);
      state.timers.drawEnd = null;
    }
    if (state.timers.drawResult) {
      clearTimeout(state.timers.drawResult);
      state.timers.drawResult = null;
    }
    if (state.drawRaf) {
      cancelAnimationFrame(state.drawRaf);
      state.drawRaf = null;
    }
  }

  function formatGps(lat, lng) {
    var ns = lat >= 0 ? 'N' : 'S';
    var ew = lng >= 0 ? 'E' : 'W';
    return Math.abs(lat).toFixed(4) + '° ' + ns + ' · ' + Math.abs(lng).toFixed(4) + '° ' + ew;
  }

  function showGpsHeader(state, coords, label) {
    var gps = state.els.gps || $('[data-gps]', state.root);
    if (gps) gps.hidden = false;
    if (state.els.gpsCoords && coords) state.els.gpsCoords.textContent = coords;
    if (state.els.gpsLabel && label) state.els.gpsLabel.textContent = label;
  }

  /* ---------- ARRIVAL ---------- */
  function renderArrival(state) {
    var c = state.cfg;
    var e = state.els;
    // Legacy single-line teaser (kept for backward compat if data-time="drop" exists)
    if (e.timeD) e.timeD.textContent = formatTeaser(c.dropAt, c.tzLabel);
    // New info-block split: date + time
    if (e.arrivalDate) e.arrivalDate.textContent = formatDateOnly(c.dropAt);
    if (e.arrivalTime) e.arrivalTime.textContent = formatTimeOnly(c.dropAt, c.tzLabel);
    // Live countdown to drop (ticks every second)
    startArrivalCountdown(state);
  }

  function startArrivalCountdown(state) {
    var el = state.els.arrivalCountdown;
    var row = state.els.arrivalCountdownRow;
    if (!el) return;
    var dropAt = state.cfg.dropAt ? state.cfg.dropAt.getTime() : null;

    if (state.timers.arrivalCountdown) {
      clearInterval(state.timers.arrivalCountdown);
      state.timers.arrivalCountdown = null;
    }

    function tick() {
      if (!dropAt) { el.textContent = '—'; return; }
      var rem = dropAt - Date.now();
      if (rem <= 0) {
        // Drop has opened — hide the row entirely (or show OPEN NOW)
        if (row) row.hidden = true;
        else el.textContent = 'OPEN NOW';
        if (state.timers.arrivalCountdown) {
          clearInterval(state.timers.arrivalCountdown);
          state.timers.arrivalCountdown = null;
        }
        return;
      }
      if (row && row.hidden) row.hidden = false;
      el.textContent = formatCountdown(rem);
    }
    tick();
    state.timers.arrivalCountdown = setInterval(tick, 1000);
  }

  function formatCountdown(ms) {
    var totalSec = Math.floor(ms / 1000);
    var days = Math.floor(totalSec / 86400);
    var hours = Math.floor((totalSec % 86400) / 3600);
    var mins = Math.floor((totalSec % 3600) / 60);
    var secs = totalSec % 60;
    if (days > 0) {
      return days + 'D ' + pad(hours) + ':' + pad(mins) + ':' + pad(secs);
    }
    return pad(hours) + ':' + pad(mins) + ':' + pad(secs);
  }
  function formatTeaser(d, tz) {
    if (!d) return '—';
    try {
      var year = d.getFullYear();
      var month = pad(d.getMonth() + 1);
      var day = pad(d.getDate());
      var hour = pad(d.getHours());
      var min = pad(d.getMinutes());
      var s = year + '.' + month + '.' + day + ' — ' + hour + ':' + min;
      if (tz) s += ' ' + tz.toUpperCase();
      return s;
    } catch (e) { return '—'; }
  }
  function formatDateOnly(d) {
    if (!d) return '—';
    try {
      return d.getFullYear() + '.' + pad(d.getMonth() + 1) + '.' + pad(d.getDate());
    } catch (e) { return '—'; }
  }
  function formatTimeOnly(d, tz) {
    if (!d) return '—';
    try {
      var h = d.getHours();
      var m = d.getMinutes();
      var meridiem = h >= 12 ? 'PM' : 'AM';
      var h12 = h % 12;
      if (h12 === 0) h12 = 12;
      var s = h12 + ':' + pad(m) + ' ' + meridiem;
      if (tz) s += ' ' + tz.toUpperCase();
      return s;
    } catch (e) { return '—'; }
  }

  /* ---------- ACCESS SCOPE (intro info-block) ---------- */
  function renderAccessScope(state) {
    var e = state.els;
    if (!e.accessScope) return;
    var current = (e.accessScope.textContent || '').trim();
    // Override only if empty or default em-dash; respect Liquid-set custom values
    if (current && current !== '—' && current !== '-') return;
    e.accessScope.textContent = computeScopeLabel(state.cfg);
  }
  function computeScopeLabel(cfg) {
    if (!cfg.geoEnabled) return 'WORLDWIDE';
    if (cfg.geoMode === 'countries') {
      var names = [];
      cfg.geoCountries.forEach(function (code) {
        if (COUNTRIES[code]) names.push(COUNTRIES[code].name.toUpperCase());
      });
      if (names.length === 0) return 'GLOBAL';
      if (names.length <= 3) return names.join(' · ');
      return names.slice(0, 2).join(' · ') + ' +' + (names.length - 2);
    }
    var cnames = [];
    cfg.geoCities.forEach(function (key) {
      if (CITIES[key]) cnames.push(CITIES[key].name.toUpperCase());
    });
    if (cnames.length === 0) return 'SELECTED CITIES';
    if (cnames.length <= 3) return cnames.join(' · ');
    return cnames.slice(0, 2).join(' · ') + ' +' + (cnames.length - 2);
  }

  /* ---------- ZONES LIST ---------- */
  function renderZonesList(state) {
    var cfg = state.cfg;
    var items = [];
    if (cfg.geoMode === 'countries') {
      cfg.geoCountries.forEach(function (code) {
        var country = COUNTRIES[code];
        if (country) items.push(country.name.toUpperCase());
      });
    } else {
      cfg.geoCities.forEach(function (key) {
        var city = CITIES[key];
        if (city) items.push(city.name.toUpperCase());
      });
    }

    // Fill info-block value (single-line, ellipsis-safe summary)
    if (state.els.zonesValue) {
      if (items.length === 0) state.els.zonesValue.textContent = '—';
      else if (items.length <= 3) state.els.zonesValue.textContent = items.join(' · ');
      else state.els.zonesValue.textContent = items.slice(0, 2).join(' · ') + ' +' + (items.length - 2);
    }

    // Legacy chips list (only if Liquid kept it)
    var list = state.els.zonesList;
    if (!list) return;
    list.innerHTML = '';
    items.forEach(function (name) {
      var span = document.createElement('span');
      span.className = 'vdh__zone-chip';
      span.textContent = name;
      list.appendChild(span);
    });
  }

  /* ---------- EVENTS ---------- */
  function bindEvents(state) {
    var root = state.root;
    var els = state.els;

    /* ---------- CONTENT PROTECTION ---------- *
     * Block right-click, drag, text selection, devtools shortcuts.
     * Preserves form input usability (text fields stay copy/paste-able).
     */
    function isFormField(target) {
      if (!target || !target.tagName) return false;
      var tag = target.tagName.toUpperCase();
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
      if (target.isContentEditable) return true;
      return false;
    }

    // Right-click
    root.addEventListener('contextmenu', function (e) {
      if (!isFormField(e.target)) e.preventDefault();
    });

    // Image drag
    root.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // Copy / cut from non-input areas
    root.addEventListener('copy', function (e) {
      if (!isFormField(e.target)) e.preventDefault();
    });
    root.addEventListener('cut', function (e) {
      if (!isFormField(e.target)) e.preventDefault();
    });

    // Selection start outside form fields
    root.addEventListener('selectstart', function (e) {
      if (!isFormField(e.target)) e.preventDefault();
    });

    // Devtools / view-source / save shortcuts
    document.addEventListener('keydown', function (e) {
      var k = (e.key || '').toLowerCase();
      // F12
      if (e.key === 'F12') { e.preventDefault(); return; }
      // Ctrl+Shift+I / J / C / K  (devtools, console, inspector)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && (k === 'i' || k === 'j' || k === 'c' || k === 'k')) {
        e.preventDefault(); return;
      }
      // Ctrl+U  (view source)
      if ((e.ctrlKey || e.metaKey) && k === 'u') { e.preventDefault(); return; }
      // Ctrl+S  (save page) — only block when not inside form
      if ((e.ctrlKey || e.metaKey) && k === 's' && !isFormField(e.target)) {
        e.preventDefault(); return;
      }
      // Ctrl+P  (print)
      if ((e.ctrlKey || e.metaKey) && k === 'p') { e.preventDefault(); return; }
    });

    /* ---------- BUTTONS ---------- */
    $$('[data-action="join"]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (state.transitioning) return;
        var phase = computePhase(state.cfg);
        if (phase === 'drawing' || phase === 'result') return show(state, 'locked');
        if (phase === 'closed') return show(state, 'closed');
        // If geo is enabled, gate behind location check first
        if (state.cfg.geoEnabled && !state.geoVerified) {
          show(state, 'locating');
        } else {
          show(state, 'email');
        }
      });
    });

    // Allow location button (on locating screen)
    $$('[data-action="request-location"]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (state.geoRequesting) return;
        requestLocation(state);
      });
    });

    if (els.form) {
      els.form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        handleSubmit(state);
        return false;
      });
    }
    // Defensive: also intercept the submit button's click, in case form submit
    // bubbles bypass somewhere (older mobile webviews, browser extensions, etc.)
    if (els.submit) {
      els.submit.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        handleSubmit(state);
        return false;
      });
    }
    if (els.email) {
      els.email.addEventListener('input', function () { hideError(state); });
    }
    if (els.firstname) {
      els.firstname.addEventListener('input', function () { hideError(state); });
    }
    if (els.lastname) {
      els.lastname.addEventListener('input', function () { hideError(state); });
    }
    if (els.optin) {
      els.optin.addEventListener('change', function () { hideError(state); });
    }

    $$('[data-action="enter-collection"]', root).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.dataset.clicked === '1') return;
        btn.dataset.clicked = '1';
        btn.disabled = true;
        btn.style.pointerEvents = 'none';
        var url = state.cfg.locksmithUrl || state.cfg.exploreUrl;
        setTimeout(function () {
          window.location.href = url;
        }, 150);
      });
    });

    $$('[data-action="exit"]', root).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        handleExitClick(state);
      });
    });

    $$('[data-action="incognito-bypass"]', root).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.dataset.clicked === '1') return;
        btn.dataset.clicked = '1';
        setIncognitoBypass();
        reevaluate(state);
      });
    });

    // Timeline accordion toggle (How it works on Arrival)
    $$('[data-timeline-toggle]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var timeline = btn.closest('[data-timeline]');
        if (!timeline) return;
        var collapsed = timeline.getAttribute('data-timeline-collapsed') === 'true';
        timeline.setAttribute('data-timeline-collapsed', collapsed ? 'false' : 'true');
        btn.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
      });
    });

    // Notify-me form (Arrival, pre-launch email capture)
    // This form posts to Shopify's /contact endpoint with form_type=customer,
    // via fetch. The form is a plain HTML form (not a {% form 'customer' %} tag)
    // and the submit is fully intercepted with preventDefault, so there is NEVER
    // a page redirect — regardless of fetch success/failure.
    $$('[data-notify]', root).forEach(function (notify) {
      var form = notify.querySelector('form');
      if (!form) return;
      var emailEl = form.querySelector('[data-notify-email]');
      var btn = form.querySelector('[data-notify-submit]');
      var btnLabel = form.querySelector('[data-notify-btn-label]');
      var errorEl = notify.querySelector('[data-notify-error]');
      var submitting = false;

      // Responsive placeholder: on mobile, the visible label is removed and
      // the call-to-action ("GET NOTIFIED") becomes the placeholder text.
      // On desktop, the placeholder is the field hint ("EMAIL") and the
      // GET NOTIFIED label sits above the input.
      if (emailEl && emailEl.dataset.mobilePlaceholder) {
        var mq = window.matchMedia('(max-width: 740px)');
        function syncPlaceholder() {
          if (!emailEl) return;
          emailEl.placeholder = mq.matches
            ? (emailEl.dataset.mobilePlaceholder || 'GET NOTIFIED')
            : (emailEl.dataset.desktopPlaceholder || 'EMAIL');
        }
        syncPlaceholder();
        try {
          if (mq.addEventListener) mq.addEventListener('change', syncPlaceholder);
          else if (mq.addListener) mq.addListener(syncPlaceholder);
        } catch (e) {}
      }

      var storageKey = 'vdh_v4_' + state.cfg.launchId + '_notify_submitted';

      // If user already submitted on a previous visit, restore the success state
      // (form hidden, success message visible). Submission is permanent per device.
      try {
        if (window.localStorage && window.localStorage.getItem(storageKey) === '1') {
          notify.classList.add('is-success');
        }
      } catch (e) {}

      function showError(msg) {
        if (!errorEl) return;
        errorEl.textContent = msg;
        errorEl.classList.add('is-visible');
      }
      function hideError() {
        if (!errorEl) return;
        errorEl.textContent = '';
        errorEl.classList.remove('is-visible');
      }
      function markSubmitted() {
        try {
          if (window.localStorage) window.localStorage.setItem(storageKey, '1');
        } catch (e) {}
        // Persistent success state — form is hidden permanently for this device,
        // no auto-revert. User cannot submit twice from the same browser.
        notify.classList.add('is-success');
      }

      form.addEventListener('submit', function (e) {
        // ABSOLUTE GUARANTEE: never let the browser navigate.
        e.preventDefault();
        e.stopPropagation();

        if (submitting) return;
        hideError();

        var email = (emailEl && emailEl.value || '').trim().toLowerCase();
        if (!email || email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showError('Please enter a valid email address.');
          if (emailEl) emailEl.focus();
          return false;
        }

        submitting = true;
        if (btn) btn.disabled = true;
        var originalLabel = btnLabel ? btnLabel.textContent : '';
        if (btnLabel) btnLabel.textContent = '...';

        if (emailEl) emailEl.value = email;

        var fd = new FormData(form);
        // POST to /contact (Shopify's newsletter endpoint). With form_type=customer
        // in the body, Shopify creates the subscriber the same way as {% form 'customer' %}
        // would, but because we drive the request entirely via fetch, there is
        // no browser navigation. Shopify's response is HTML (we ignore it).
        fetch('/contact', {
          method: 'POST',
          body: fd,
          credentials: 'same-origin',
          headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function () { markSubmitted(); })
          .catch(function () {
            // Network error — still show success (privacy-safe newsletter UX),
            // but don't persist so the user can retry on next visit.
            notify.classList.add('is-success');
          })
          .finally(function () {
            submitting = false;
            if (btn) btn.disabled = false;
            if (btnLabel) btnLabel.textContent = originalLabel;
          });

        return false;
      });
    });

    $$('[data-modal-close]', root).forEach(function (el) {
      el.addEventListener('click', function () { closeModal(state); });
    });
    $$('[data-modal-confirm]', root).forEach(function (el) {
      el.addEventListener('click', function () {
        setTimeout(function () { confirmLeave(state); }, 100);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && els.modal && !els.modal.hidden) {
        closeModal(state);
      }
    });

    if (els.debugReset) {
      els.debugReset.addEventListener('click', function () {
        clearEntry(state);
        try {
          var url = new URL(window.location.href);
          url.searchParams.delete('customer_posted');
          url.hash = '';
          window.location.href = url.pathname;
        } catch (e) { window.location.reload(); }
      });
    }
  }

  /* ---------- EXIT ---------- */
  function handleExitClick(state) {
    if (state.current === 'waiting') openModal(state);
    else redirectExit(state);
  }
  function confirmLeave(state) {
    if (state.current === 'waiting') clearEntry(state);
    redirectExit(state);
  }
  function redirectExit(state) {
    window.location.href = state.cfg.exitUrl || '/';
  }
  function clearEntry(state) {
    Object.keys(state.keys).forEach(function (k) { lsDel(state.keys[k]); });
  }
  function openModal(state) {
    var m = state.els.modal;
    if (!m) return;
    m.hidden = false;
    m.setAttribute('aria-hidden', 'false');
  }
  function closeModal(state) {
    var m = state.els.modal;
    if (!m) return;
    m.hidden = true;
    m.setAttribute('aria-hidden', 'true');
  }

  /* ---------- BOOT ---------- */
  function boot(state) {
    // Preview mode bypasses everything (including incognito check)
    // so the Shopify admin can preview all views.
    if (state.cfg.preview && state.cfg.preview !== 'live') {
      show(state, state.cfg.preview);
      return;
    }

    // Skip incognito check if user already bypassed it this session
    if (incognitoBypassed()) {
      reevaluate(state);
      return;
    }

    detectIncognito().then(function (isPrivate) {
      if (isPrivate) {
        show(state, 'incognito');
      } else {
        reevaluate(state);
      }
    });
  }

  function incognitoBypassed() {
    try {
      return window.sessionStorage.getItem('vdh_incognito_bypassed') === '1';
    } catch (e) {
      return false;
    }
  }

  function setIncognitoBypass() {
    try {
      window.sessionStorage.setItem('vdh_incognito_bypassed', '1');
    } catch (e) {}
  }

  /* Signed read of result */
  function readResult(state) {
    var r = lsGet(state.keys.result);
    var sig = lsGet(state.keys.sig);
    if (r !== 'granted' && r !== 'denied') return null;
    if (sig !== signValue(r, state.cfg.launchId)) {
      // Signature mismatch — tampered or stale, clear
      clearEntry(state);
      return null;
    }
    return r;
  }

  function isEntered(state) {
    return lsGet(state.keys.entered) === '1';
  }

  function markEntered(state, result) {
    lsSet(state.keys.entered, '1');
    lsSet(state.keys.result, result);
    lsSet(state.keys.sig, signValue(result, state.cfg.launchId));
    lsSet(state.keys.ts, String(Date.now()));
  }

  function reevaluate(state) {
    if (state.cfg.preview && state.cfg.preview !== 'live') return;
    // Don't yank user out of incognito blocker unless they bypassed
    if (state.current === 'incognito' && !incognitoBypassed()) return;
    if (state.current === 'locating' || state.current === 'out_of_scope') return;
    if (state.current === 'email') return; // don't yank user out of form

    var phase = computePhase(state.cfg);
    var entered = isEntered(state);
    var result = readResult(state);
    var current = state.current;

    // CRITICAL GUARD: if the user is marked as "entered" but the participation window
    // hasn't opened yet, this is a corrupted/stale state. You can't have entered
    // a draw that hasn't opened. Clear the entry and let the normal flow show Arrival.
    // This guarantees that submitting the pre-launch notify form (which never marks
    // entered) cannot accidentally land the user in the waiting room — even if a
    // stale `entered=1` marker exists from a previous test or session.
    if (entered && phase === 'before') {
      clearEntry(state);
      entered = false;
      result = null;
    }

    if (entered) {
      if (phase === 'closed') {
        if (current !== 'closed') show(state, 'closed');
        return;
      }
      if (phase === 'participation' || phase === 'waiting' || phase === 'locked') {
        if (current !== 'waiting') show(state, 'waiting');
        return;
      }
      if (phase === 'drawing') {
        if (current !== 'drawing') show(state, 'drawing');
        return;
      }
      if (phase === 'result') {
        var r = result || decideAccess(state.cfg);
        if (!result) markEntered(state, r);
        var target = r === 'granted' ? 'granted' : 'denied';
        if (current !== target) show(state, target);
        return;
      }
    }

    if (phase === 'before') {
      if (current !== 'arrival') show(state, 'arrival');
      return;
    }
    if (phase === 'participation') {
      if (current !== 'intro') show(state, 'intro');
      return;
    }
    if (phase === 'waiting' || phase === 'locked' || phase === 'drawing' || phase === 'result') {
      if (current !== 'locked') show(state, 'locked');
      return;
    }
    if (current !== 'closed') show(state, 'closed');
  }

  function computePhase(cfg) {
    var now = Date.now();
    var p = cfg.partOpensAt ? cfg.partOpensAt.getTime() : null;
    var c = cfg.entriesCloseAt ? cfg.entriesCloseAt.getTime() : null;
    var s = cfg.drawStartsAt ? cfg.drawStartsAt.getTime() : null;
    var u = cfg.unlockAt ? cfg.unlockAt.getTime() : null;
    var x = cfg.resultsExpireAt ? cfg.resultsExpireAt.getTime() : null;
    if (!p) return 'participation';
    if (now < p) return 'before';
    if (c && now < c) return 'participation';
    if (s && now < s) return 'waiting';
    if (u && now < u) return 'drawing';
    if (x && now < x) return 'result';
    return 'closed';
  }

  /* ---------- ENTRY COUNTDOWN ---------- */
  function startEntryCountdown(state) {
    stopEntryCountdown(state);
    var el = state.els.entry;
    if (!el) return;
    var cfg = state.cfg;
    var isPreview = cfg.preview && cfg.preview !== 'live';
    // In preview, fake a ~10min entry window so it visibly counts down
    var closeAt = isPreview
      ? Date.now() + 10 * 60 * 1000
      : (cfg.entriesCloseAt ? cfg.entriesCloseAt.getTime() : null);

    function tick() {
      if (!closeAt) { el.textContent = '--:--'; return; }
      var rem = closeAt - Date.now();
      if (rem <= 0) {
        el.textContent = '00:00';
        stopEntryCountdown(state);
        // In preview, don't auto-transition
        if (!isPreview) reevaluate(state);
        return;
      }
      var totalSec = Math.floor(rem / 1000);
      el.textContent = pad(Math.floor(totalSec / 60)) + ':' + pad(totalSec % 60);
    }
    tick();
    state.timers.entry = setInterval(tick, 1000);
  }

  /* ---------- EMAIL SUBMIT ---------- */
  function handleSubmit(state) {
    if (state.submitting) return;
    var els = state.els;
    var rawEmail = (els.email && els.email.value || '').trim();
    var email = rawEmail.toLowerCase().substring(0, MAX_EMAIL_LEN);
    var firstname = (els.firstname && els.firstname.value || '').trim();
    var lastname = (els.lastname && els.lastname.value || '').trim();
    var optin = els.optin ? !!els.optin.checked : false;

    if (!firstname || firstname.length < 1) {
      showError(state, 'Please enter your first name.');
      if (els.firstname) els.firstname.focus();
      return;
    }
    if (!lastname || lastname.length < 1) {
      showError(state, 'Please enter your last name.');
      if (els.lastname) els.lastname.focus();
      return;
    }
    if (!isValidEmail(email)) {
      showError(state, 'Please enter a valid email.');
      if (els.email) els.email.focus();
      return;
    }
    if (!optin) {
      showError(state, 'Please confirm to continue.');
      return;
    }

    state.submitting = true;
    setLoading(state, true);
    hideError(state);

    if (!els.form) {
      afterEmailSubmit(state);
      return;
    }

    // Sanitize the email field
    if (els.email) els.email.value = email;

    // Encode firstname + lastname into contact[tags] so Shopify saves them
    // on the customer record (the only officially supported field is contact[email],
    // so we use tags as a side-channel for the name data).
    // Format: launch,launch-{id},firstname:{name},lastname:{name}
    var tagsField = els.form.querySelector('[data-tags-field]');
    if (tagsField) {
      var safeFirst = firstname.replace(/[,;]/g, ' ').substring(0, 60);
      var safeLast = lastname.replace(/[,;]/g, ' ').substring(0, 60);
      var baseTags = tagsField.value || ('launch,launch-' + state.cfg.launchId);
      tagsField.value = baseTags
        + ',firstname:' + safeFirst
        + ',lastname:' + safeLast;
    }

    // Pre-decide the access result and persist it BEFORE the native submit,
    // because the page is about to reload after Shopify's redirect.
    // On reload, customer_posted=true triggers the post-redirect handler
    // which calls markEntered() — but we want OUR decided result, not a new one.
    var result = decideAccess(state.cfg);
    markEntered(state, result);

    // Native submit — Shopify handles the POST + redirect properly.
    // This is the supported submit path; fetch() POST is unofficial and unreliable.
    try {
      els.form.submit();
    } catch (err) {
      // Fallback: if for any reason native submit fails, advance the UI manually
      afterEmailSubmit(state);
    }
  }

  function afterEmailSubmit(state) {
    state.submitting = false;
    setLoading(state, false);
    grantEntry(state);
  }

  function grantEntry(state) {
    var result = decideAccess(state.cfg);
    markEntered(state, result);

    var phase = computePhase(state.cfg);
    if (phase === 'before' || phase === 'participation' || phase === 'waiting') {
      show(state, 'waiting');
    } else if (phase === 'drawing') {
      show(state, 'drawing');
    } else if (phase === 'result') {
      show(state, result === 'granted' ? 'granted' : 'denied');
    } else {
      show(state, 'closed');
    }
  }

  /* ---------- GEOLOCATION ---------- */
  function startLocating(state) {
    // Just prepare the screen; permission is requested when the user clicks the button
    var els = state.els;
    drawZoneSvg(state);
    if (els.mapStatus) els.mapStatus.textContent = 'AWAITING PERMISSION';
    // Reset button state if user came back
    var btn = $('[data-action="request-location"]', state.root);
    var btnLabel = $('[data-locating-btn-label]', state.root);
    if (btn) {
      btn.disabled = false;
      // Restore original label from the data attribute we cache on first render
      if (btnLabel && !btnLabel.dataset.originalText) {
        btnLabel.dataset.originalText = btnLabel.textContent;
      }
      if (btnLabel && btnLabel.dataset.originalText) {
        btnLabel.textContent = btnLabel.dataset.originalText;
      }
    }
  }

  function requestLocation(state) {
    if (state.geoRequesting) return;
    if (!('geolocation' in navigator)) {
      handleGeoFail(state, 'GEOLOCATION NOT SUPPORTED');
      return;
    }
    state.geoRequesting = true;
    var els = state.els;
    var btn = $('[data-action="request-location"]', state.root);
    var btnLabel = $('[data-locating-btn-label]', state.root);
    if (btn) btn.disabled = true;
    if (btnLabel) {
      if (!btnLabel.dataset.originalText) btnLabel.dataset.originalText = btnLabel.textContent;
      btnLabel.textContent = 'CHECKING…';
    }
    if (els.mapStatus) els.mapStatus.textContent = 'CHECKING LOCATION…';

    navigator.geolocation.getCurrentPosition(
      function (pos) {
        state.geoRequesting = false;
        handleGeoSuccess(state, pos.coords.latitude, pos.coords.longitude);
      },
      function (err) {
        state.geoRequesting = false;
        var msg = 'PERMISSION DENIED';
        if (err && err.code === 2) msg = 'POSITION UNAVAILABLE';
        if (err && err.code === 3) msg = 'TIMEOUT';
        if (btn) btn.disabled = false;
        if (btnLabel) btnLabel.textContent = btnLabel.dataset.originalText || 'TRY AGAIN';
        handleGeoFail(state, msg);
      },
      { timeout: 12000, enableHighAccuracy: false, maximumAge: 0 }
    );
  }

  function handleGeoSuccess(state, lat, lng) {
    var inScope = checkScope(state.cfg, lat, lng);
    var coords = formatGps(lat, lng);
    var label = inScope.matched ? inScope.matched.toUpperCase() : (state.cfg.tzLabel || '');

    // Show GPS in header (was hidden until now)
    showGpsHeader(state, coords, label);

    placeDot(state, inScope.matched);
    if (state.els.mapStatus) {
      state.els.mapStatus.textContent = inScope.inside
        ? ('IN ZONE · ' + (inScope.matched ? inScope.matched.toUpperCase() : ''))
        : 'OUT OF ZONE';
    }

    if (state.timers.geoFollowup) clearTimeout(state.timers.geoFollowup);
    state.timers.geoFollowup = setTimeout(function () {
      state.timers.geoFollowup = null;
      if (inScope.inside) {
        state.geoVerified = true;
        show(state, 'email');
      } else {
        show(state, 'out_of_scope');
      }
    }, 1600);
  }

  function handleGeoFail(state, msg) {
    if (state.els.mapStatus) state.els.mapStatus.textContent = msg;
    if (state.timers.geoFollowup) clearTimeout(state.timers.geoFollowup);
    state.timers.geoFollowup = setTimeout(function () {
      state.timers.geoFollowup = null;
      show(state, 'out_of_scope');
    }, 1400);
  }
  function checkScope(cfg, lat, lng) {
    if (cfg.geoMode === 'countries') {
      for (var i = 0; i < cfg.geoCountries.length; i++) {
        var country = COUNTRIES[cfg.geoCountries[i]];
        if (!country) continue;
        var b = country.bbox;
        if (lat >= b[0] && lat <= b[2] && lng >= b[1] && lng <= b[3]) {
          return { inside: true, matched: country.name };
        }
      }
      return { inside: false, matched: null };
    }
    for (var j = 0; j < cfg.geoCities.length; j++) {
      var city = CITIES[cfg.geoCities[j]];
      if (!city) continue;
      var dist = haversineKm(lat, lng, city.lat, city.lng);
      if (dist <= city.radius) return { inside: true, matched: city.name };
    }
    return { inside: false, matched: null };
  }
  function drawZoneSvg(state) {
    var cfg = state.cfg;
    var zone = state.els.mapZone;
    var rings = state.els.mapRings;
    if (!zone) return;

    zone.innerHTML = '';
    if (cfg.geoMode === 'cities' && cfg.geoCities.length === 1) {
      var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      c.setAttribute('cx', '160');
      c.setAttribute('cy', '160');
      c.setAttribute('r', '90');
      zone.appendChild(c);
    } else if (cfg.geoMode === 'cities') {
      var positions = [[80,100],[240,100],[80,200],[240,200],[160,60],[160,260]];
      var cities = cfg.geoCities.slice(0, 6);
      cities.forEach(function (key, i) {
        if (CITIES[key] && positions[i]) {
          var c2 = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
          c2.setAttribute('cx', positions[i][0]);
          c2.setAttribute('cy', positions[i][1]);
          c2.setAttribute('r', '32');
          zone.appendChild(c2);
        }
      });
    } else {
      var r = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      r.setAttribute('x', '50');
      r.setAttribute('y', '50');
      r.setAttribute('width', '220');
      r.setAttribute('height', '220');
      zone.appendChild(r);
    }

    if (rings) {
      rings.innerHTML = '';
      for (var i = 0; i < 3; i++) {
        var rc = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        rc.setAttribute('cx', '160');
        rc.setAttribute('cy', '160');
        rc.setAttribute('r', '4');
        rings.appendChild(rc);
      }
    }
  }
  function placeDot(state, matchedName) {
    var dot = state.els.mapDot;
    if (!dot) return;
    var cfg = state.cfg;
    var x = 160, y = 160;

    if (cfg.geoMode === 'cities' && cfg.geoCities.length > 1 && matchedName) {
      var positions = [[80,100],[240,100],[80,200],[240,200],[160,60],[160,260]];
      var idx = -1;
      cfg.geoCities.slice(0, 6).forEach(function (key, i) {
        if (CITIES[key] && CITIES[key].name === matchedName) idx = i;
      });
      if (idx >= 0 && positions[idx]) {
        x = positions[idx][0];
        y = positions[idx][1];
      }
    } else if (!matchedName) {
      x = 280;
      y = 280;
    }

    dot.setAttribute('cx', x);
    dot.setAttribute('cy', y);
    dot.classList.add('is-visible');
  }

  /* ---------- ACCESS DECISION ---------- */
  function decideAccess(cfg) {
    if (cfg.disableSelection) return 'granted';
    var p = clamp(cfg.probability, MIN_PROBABILITY, MAX_PROBABILITY, 50);
    if (p >= 100) return 'granted';
    if (p <= 0) return 'denied';
    var roll = secureRandom() * 100;
    return roll < p ? 'granted' : 'denied';
  }

  function setLoading(state, on) {
    if (state.els.submit) {
      state.els.submit.disabled = !!on;
      if (on) state.els.submit.classList.add('is-loading');
      else state.els.submit.classList.remove('is-loading');
    }
    if (state.els.submitLabel) {
      state.els.submitLabel.textContent = on ? 'JOINING…' : (state.cfg.submitDefault || 'CONFIRM ENTRY');
    }
  }
  function showError(state, msg) {
    if (!state.els.error) return;
    state.els.error.textContent = msg;
    state.els.error.setAttribute('data-visible', 'true');
  }
  function hideError(state) {
    if (state.els.error) state.els.error.setAttribute('data-visible', 'false');
  }

  /* ---------- WAITING ---------- */
  function startWaitingCountdown(state) {
    stopWaitingExtras(state);

    var cfg = state.cfg;
    var els = state.els;
    var isPreview = cfg.preview && cfg.preview !== 'live';

    // In preview, fake a countdown ~5 min into the future so it visibly counts down
    var drawStartsAt = isPreview
      ? Date.now() + 5 * 60 * 1000
      : (cfg.drawStartsAt ? cfg.drawStartsAt.getTime() : null);
    var enteredAt = isPreview
      ? Date.now() - 30 * 1000  // pretend we entered 30s ago for visible progress
      : safeInt(lsGet(state.keys.ts), Date.now());

    function setFlipDigit(idx, ch) {
      if (!els.flipclock) return;
      var digit = els.flipclock.querySelector('[data-flip="' + idx + '"]');
      if (!digit) return;
      if (state.lastFlipDigits[idx] === ch) return;
      digit.textContent = ch;
      digit.classList.remove('is-flipping');
      void digit.offsetWidth;
      digit.classList.add('is-flipping');
      state.lastFlipDigits[idx] = ch;
    }

    function tick() {
      if (!drawStartsAt) {
        ['0','0','0','0'].forEach(function (c, i) { setFlipDigit(i, c); });
        return;
      }
      var now = Date.now();
      var rem = drawStartsAt - now;
      if (rem <= 0) {
        ['0','0','0','0'].forEach(function (c, i) { setFlipDigit(i, c); });
        if (els.progress) els.progress.style.inset = '0 0 0 0';
        if (els.waitingOverlay) els.waitingOverlay.style.background = 'rgba(243,243,243,0.65)';
        stopWaitingExtras(state);
        // In preview, don't auto-transition — stay on the preview view
        if (!isPreview) show(state, 'drawing');
        return;
      }
      var totalSec = Math.floor(rem / 1000);
      var m = Math.floor(totalSec / 60);
      var s = totalSec % 60;
      var str = pad(m) + pad(s);
      for (var i = 0; i < 4; i++) setFlipDigit(i, str.charAt(i));

      var span = drawStartsAt - enteredAt;
      if (span > 0) {
        var elapsed = now - enteredAt;
        var pct = clamp((elapsed / span) * 100, 0, 100, 0);
        if (els.progress) els.progress.style.inset = '0 ' + (100 - pct).toFixed(2) + '% 0 0';
        if (els.waitingOverlay) {
          // 0.94 → 0.65 over the wait period
          var alpha = 0.94 - (pct / 100) * 0.29;
          els.waitingOverlay.style.background = 'rgba(243,243,243,' + alpha.toFixed(3) + ')';
        }
      }
    }
    tick();
    state.timers.wait = setInterval(tick, 1000);

    var statuses = cfg.waitingStatuses;
    var idx = 0;
    state.timers.status = setInterval(function () {
      idx = (idx + 1) % statuses.length;
      if (els.waitingStatus) els.waitingStatus.textContent = statuses[idx];
    }, 5000);

    // Footer message cycling
    var msgs = cfg.waitingMessages;
    var mIdx = 0;
    if (els.waitingMessage) els.waitingMessage.textContent = msgs[0];
    state.timers.queue = setInterval(function () {
      if (!els.waitingMessage) return;
      els.waitingMessage.classList.add('is-fading');
      setTimeout(function () {
        mIdx = (mIdx + 1) % msgs.length;
        els.waitingMessage.textContent = msgs[mIdx];
        els.waitingMessage.classList.remove('is-fading');
      }, 350);
    }, 4000);
  }

  /* ---------- DRAWING ---------- */
  function startDrawing(state) {
    stopDrawing(state);

    var cfg = state.cfg;
    var els = state.els;
    var isPreview = cfg.preview && cfg.preview !== 'live';

    var endsAt;
    if (isPreview) {
      endsAt = Date.now() + cfg.timings.DRAW_DURATION_MS;
    } else {
      endsAt = cfg.unlockAt ? cfg.unlockAt.getTime() : Date.now() + cfg.timings.DRAW_DURATION_MS;
    }

    var chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    function randomEmail() {
      var n = 4 + Math.floor(secureRandom() * 8);
      var s = '';
      for (var i = 0; i < n; i++) s += chars.charAt(Math.floor(secureRandom() * chars.length));
      return s + '••••@••••.com';
    }

    if (els.drawStream) els.drawStream.textContent = randomEmail();

    var lastTick = performance.now();
    var nextDelay = 60;
    var finished = false;

    // Decelerate as we approach end
    function getDelay() {
      var remMs = endsAt - Date.now();
      if (remMs > 5000) return 60;
      if (remMs > 4000) return 120;
      if (remMs > 3000) return 220;
      if (remMs > 2000) return 400;
      if (remMs > 800)  return 700;
      return 1100;
    }

    function loop(now) {
      if (finished) return;
      if (now - lastTick >= nextDelay) {
        if (els.drawStream) els.drawStream.textContent = randomEmail();
        lastTick = now;
        nextDelay = getDelay();
      }
      state.drawRaf = requestAnimationFrame(loop);
    }
    state.drawRaf = requestAnimationFrame(loop);

    state.timers.drawTime = setInterval(function () {
      var rem = Math.max(0, Math.ceil((endsAt - Date.now()) / 1000));
      var m = Math.floor(rem / 60);
      var s = rem % 60;
      if (els.drawTime) els.drawTime.textContent = pad(m) + ':' + pad(s);

      if (rem <= 0) {
        finished = true;
        if (state.drawRaf) { cancelAnimationFrame(state.drawRaf); state.drawRaf = null; }
        if (state.timers.drawTime) { clearInterval(state.timers.drawTime); state.timers.drawTime = null; }
        if (els.drawStream) els.drawStream.textContent = randomEmail();

        // In preview, just restart the loop so the user can keep watching
        if (isPreview) {
          state.timers.drawRestart = setTimeout(function () {
            state.timers.drawRestart = null;
            startDrawing(state);
          }, 800);
          return;
        }

        state.timers.drawEnd = setTimeout(function () {
          state.timers.drawEnd = null;
          fireFlash();
          state.timers.drawResult = setTimeout(function () {
            state.timers.drawResult = null;
            var result = readResult(state);
            if (!result) {
              result = decideAccess(cfg);
              markEntered(state, result);
            }
            show(state, result === 'granted' ? 'granted' : 'denied');
          }, 200);
        }, 500);
      }
    }, 250);
  }

  function fireFlash() {
    var existing = document.querySelector('.vdh__flash');
    if (existing) existing.remove();
    var flash = document.createElement('div');
    flash.className = 'vdh__flash is-firing';
    document.body.appendChild(flash);
    setTimeout(function () { if (flash.parentNode) flash.parentNode.removeChild(flash); }, 350);
  }

})();